<template>
<div class="loyalit-redeem-item pt15">
  <div class="loyalty-redeem-header is-flex justify-content-between columns">
    <div class="column is-8 is-3 pb0">
      <h3 class="has-text-weight-semibold is-capitalized">{{ title }}</h3>
      <p class="has-text-weight-light is-size-14">{{ record.location_data ? record.location_data.name : '' }}</p>
    </div>
    <div class="column pb0 has-text-right">
      <p class="has-text-weight-light is-size-14">{{ readAbleDate(record.created_at) }}</p>
    </div>
  </div>
  <div class="columns loyalty-redeem-footer is-flex justify-content-between align-items-end">
    <div class="column is-5-desktop is-8-mobile is-6-tablet is-flex"> 
      <div class="redeem-point-used mr25">
        <p class="has-text-weight-light is-size-14"> Points used<br/>
        <span class="point-used has-text-weight-semibold">{{ new Intl.NumberFormat().format(record.points_redeemed) }}</span></p>
      </div>
      <div class="redeem-point-earned">
        <p class="has-text-weight-light is-size-14"> Points earned<br/>
        <span class="points-earned has-text-weight-semibold">{{ new Intl.NumberFormat().format(record.points_earned) }}</span></p>
      </div>
    </div>
    <div class="column has-text-right">
      <a href="#" v-if="record.tx_type == 'ecomm_order'" @click.prevent="showReceipt()" class="has-text-weight-semibold hover-text-primary font-color">VIEW DETAILS</a>
    </div>
  </div>
</div>
</template>

<script>
import moment from 'moment';
import { mapGetters, mapActions } from "vuex";
import OrderHistoryApis from '@/Components/Controllers/OrderHistoryApis';
import Helpers from '@/Components/Helpers/Helpers';

export default {
  props: ['record'],
  data() {
    return {
      loyaltyHeading: {
        ecomm_order: 'place order',
        welcome_bonus: 'signup points',
        app_bonus: 'app actions',
        store_checkin_bonus: 'store check-in',
        point_adjustment: 'Manual adjustment by business',
        client_point_adjustment: 'client points adjustments',
        void: 'void',
        birthday_bonus: 'birthday bonus',
        anniversary_bonus: 'anniversary bonus',
        referral_bonus: 'referral bonus',
        referral_joining_bonus: 'referral joining bonus',
        badge_reward: 'badge bonus',
        order_placed_badge_reward: 'Badge for placing orders',
        total_spent_badge_reward: 'Badge earned',
        item_purchase_badge_reward: 'Badge earned',
        category_purchase_badge_reward: 'Badge earned',
        action_completed_badge_reward: 'Badge earned',
        reward_redeemed: 'Reward redeemed'
      }
    }
  },
   computed: {
    
    title() {
      if (this.loyaltyHeading[this.record.tx_type] != undefined) {
        if(this.record.tx_type == 'point_adjustment') {
           return 'Manual adjustment by ' + (this.vg_businessProfile && this.vg_businessProfile.name ? this.vg_businessProfile.name : ' business');
        }
        if(this.record.transaction_details && this.record.transaction_details.length > 0 && this.record.transaction_details[0].badge_id && this.record.transaction_details[0].details && this.record.transaction_details[0].details.badge){          
          return this.loyaltyHeading[this.record.tx_type] + ' - ' + this.record.transaction_details[0].details.badge;
        }
        return this.loyaltyHeading[this.record.tx_type];
      }
      return 'Order#'+ this.record.ref_id;
    },

    ...mapGetters({
      vg_businessProfile: "businessprofile/detail",
    })
  },

  methods: {
   
    /**
     * Make date readable
     */
    readAbleDate(str) {
      if (_.isEmpty(str)) return;
      return moment(str).format('DD/MM/YYYY');
    },

    /**
     * Fetch order and pass to modal
     */
    async showReceipt() {
      /// hit api get data pass it on 
      this.va_spinner(true);
      let res = await OrderHistoryApis.fetchOrderById(this.record.ref_id )
      this.va_spinner(false);
      if(res.status == 200){
        bus.$emit("show-modal-order-recepit", {
          order: res.data.payload,
          modal: true
        });
      } else {
        // no data found 
        this.va_snackbar({
          type: 'warning', 
          message: res.response.data ? res.response.data.msg : Helpers.catchErrorMessage(res.response.data),
        })
      }
    },

    ...mapActions({
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
    })

  },
}
</script>